import { useEffect } from 'react';
import NaiveBayesView from './ui/knn-view';
import KnnParameters from './ui/knn-parameters';
import { useKnnStore } from './dal/knn-store';
import { IKnnParameters } from './knn-interfaces';

const initialParameters: IKnnParameters = {
    "k": 5,
    "titles": [
        "x1", "x2"
    ],
    "rows": [
        [40, 20],
        [50, 50],
        [60, 90],
        [10, 25],
        [70, 70],
        [60, 10],
        [25, 80]
    ],
    "targetName": "color",
    "targetValues": [
        "red",
        "blue",
        "blue",
        "red",
        "blue",
        "red",
        "blue"
    ],
    "question":  [20, 35]
};

const KnnHome = () => {

    const params = useKnnStore(store => store.params);
    const setParams = useKnnStore(store => store.setParams);

    useEffect(() => {
        setParams(initialParameters);
    }, [setParams]);

    return(
        <div className="w-full py-2 overflow-auto">

            <div className="w-full mb-4">
                <h1 className="text-2xl px-2 mb-4">KNN Classifier</h1>

                {
                    params &&
                    <div className="flex gap-4 ml-2">
                        <KnnParameters />
                        <NaiveBayesView />
                    </div>
                }
            </div>

        </div>
    )
};

export default KnnHome;
